import React, {useState, useEffect } from "react";
import Toggle from "../toggle/Toggle";
import './Navbar.css';
import {Link} from 'react-scroll';
import { useTranslation } from "react-i18next";

const Navbar = () => {

    const [t, i18n] = useTranslation("global");
    const [sticky, setSticky] = useState(false);

    useEffect(()=>{
        const handleScroll= ()=>{
            const isSticky= window.scrollY > 0;
            setSticky(isSticky);
        };
        window.addEventListener("scroll", handleScroll);
        return()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    },[]);

    return(
    <div className={`n-container ${sticky ? "sticky" : ""}`}>
        <div className="n-wrapper">

            <div className="n-left">

                <Link spy={true} to='Intro'smooth={true} activeClass='activeClass' >
                <div className="n-name" style={{ cursor: 'pointer'}} > Sol Olmos</div>
                </Link>

                <Toggle></Toggle>

                <div className="btlan">

                <label classNamr="switch">
                <div className="round"><input name="onoff" id="onoff" type="checkbox"/>
                <div className="back"><label htmlFor="onoff" class="but">
                    <span className="on" onClick={()=>i18n.changeLanguage("en")}>EN</span>
                    <span className="off" onClick={()=>i18n.changeLanguage("es")}>ES</span></label></div>
                </div>
                </label>
                </div>

               {/*  <button onClick={()=>i18n.changeLanguage("es")}>ES</button>
                <button onClick={()=>i18n.changeLanguage("en")}>EN</button> */}
            </div>

            <div className="n-right">
                <div className="n-list">
                    <ul style={{listStyleType:'none'}}>

                        <Link spy={true} to='Intro'smooth={true} activeClass='activeClass' >
                            <li className="item">{t("Navbar.about_me")}</li>
                        </Link>

                        <Link spy={true} to='Services' smooth={true} activeClass='activeClass' >
                            <li className="item">{t("Navbar.services")}</li>
                        </Link>

                        <Link spy={true} to='Experience' smooth={true} activeClass='activeClass' >
                            <li className="item" >{t("Navbar.experience")}</li>
                        </Link>

                        <Link spy={true} to='Projects' smooth={true} activeClass='activeClass' >
                            <li className="item">{t("Navbar.projects")}</li>
                        </Link>
                        <Link spy={true} to='Portfolio' smooth={true} activeClass='activeClass' >
                            <li className="item">{t("Navbar.portfolio")}</li>
                        </Link>
                        
                    </ul>

                </div>

                <Link spy={true} to='Contact' smooth={true} activeClass='activeClass' >
                <button className="button n-button">
                 {t("Navbar.contact_me")}
                </button>
                </Link>

            </div>

        </div>
     </div>
    )
}

export default Navbar